import { type MutableRefObject, useRef } from 'react';

/**
 * Ref that always holds the latest `value` from the current render. Event handlers can
 * read `ref.current` to merge rapid UI updates (e.g. Fluent multiselect) without stale
 * closures, while the tree is still controlled from props/state on the next paint.
 */
export const useSyncedRef = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
